/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_Download_LinkInputs */



/**
* | output |
* | --- |
* | "Download the desktop app" |
*
* @param {Open_In_Desktop_Download_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_download_link = /** @type {((inputs?: Open_In_Desktop_Download_LinkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_Download_LinkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargez l'application de bureau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden Sie die Desktop-App herunter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica l'applicazione desktop")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузите настольное приложение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descarga la aplicación de escritorio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载桌面应用程序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デスクトップアプリをダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेस्कटॉप ऐप डाउनलोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixe o aplicativo para desktop")
	return /** @type {LocalizedString} */ ("Download the desktop app")
});